<template>
  <div class="not-found">
    <div class="container">
      <div class="title">404</div>

      <div class="message">The page you were looking for doesn't exists.</div>

      <div class="navigate">
        <router-link to="/" exact tag="div" class="button text-uppercase">Go to home page</router-link>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NotFound'
  }
</script>

<style scoped>

</style>
